module.exports = __webpack_public_path__ + "assets/img/hstart.70d0cbf8.png";